export const commonConstants = {
  VEHICLES_MASTER_API: "/common/get-vehicle-models/{id}",
  VEHICLES_MASTER_SAGA: "VEHICLES_MASTER_SAGA",
  VEHICLES_MASTER_REQUEST: "VEHICLES_MASTER_REQUEST",
  VEHICLES_MASTER_RESPONSE: "VEHICLES_MASTER_RESPONSE",

  VEHICLES_MANUFACTURER_API: "common/get-vehicle-master-list",
  VEHICLES_MANUFACTURER_SAGA: "VEHICLES_MANUFACTURER_SAGA",
  VEHICLES_MANUFACTURER_REQUEST: "VEHICLES_MANUFACTURER_REQUEST",
  VEHICLES_MANUFACTURER_RESPONSE: "VEHICLES_MANUFACTURER_RESPONSE",

  LOCATION_API: "/all/charging-stations",
  LOCATION_SAGA: "LOCATION_SAGA",
  LOCATION_REQUEST: "LOCATION_REQUEST",
  LOCATION_RESPONSE: "LOCATION_RESPONSE",

  AMENITIES_API: "common/get-amenities",
  AMENITIES_SAGA: "AMENITIES_SAGA",
  AMENITIES_REQUEST: "AMENITIES_REQUEST",
  AMENITIES_RESPONSE: "AMENITIES_RESPONSE",

  NETWORK_API: "networks",
  NETWORK_SAGA: "NETWORK_SAGA",
  NETWORK_REQUEST: "NETWORK_REQUEST",
  NETWORK_RESPONSE: "NETWORK_RESPONSE",

  ATTACHMENT_UPLOAD_API: "/attachment",
  ATTACHMENT_UPLOAD_SAGA: "ATTACHMENT_UPLOAD_SAGA",
  ATTACHMENT_UPLOAD_REQUEST: "ATTACHMENT_UPLOAD_REQUEST",
  ATTACHMENT_UPLOAD_RESPONSE: "ATTACHMENT_UPLOAD_RESPONSE",

  ATTACHMENT_DOWNLOAD_API: "/attachment/:id",
  ATTACHMENT_DOWNLOAD_SAGA: "ATTACHMENT_DOWNLOAD_SAGA",
  ATTACHMENT_DOWNLOAD_REQUEST: "ATTACHMENT_DOWNLOAD_REQUEST",
  ATTACHMENT_DOWNLOAD_RESPONSE: "ATTACHMENT_DOWNLOAD_RESPONSE",

  ATTACHMENT_DELETE_API: "/attachment/:id",
  ATTACHMENT_DELETE_SAGA: "ATTACHMENT_DELETE_SAGA",
  ATTACHMENT_DELETE_REQUEST: "ATTACHMENT_DELETE_REQUEST",
  ATTACHMENT_DELETE_RESPONSE: "ATTACHMENT_DELETE_RESPONSE",

  ATTACHMENT_UPDATE_API: "/attachment",
  ATTACHMENT_UPDATE_SAGA: "ATTACHMENT_UPDATE_SAGA",
  ATTACHMENT_UPDATE_REQUEST: "ATTACHMENT_UPDATE_REQUEST",
  ATTACHMENT_UPDATE_RESPONSE: "ATTACHMENT_UPDATE_RESPONSE",

  // charger type
  CHARGER_TYPES_API: "/common/charger-types",
  CHARGER_TYPES_SAGA: "CHARGER_TYPES_SAGA",
  CHARGER_TYPES_REQUEST: "CHARGER_TYPES_REQUEST",
  CHARGER_TYPES_RESPONSE: "CHARGER_TYPES_RESPONSE",

  SET_AMENITIES_API: "common/get-amenities",
  SET_AMENITIES_SAGA: "SET_AMENITIES_SAGA",
  SET_AMENITIES_REQUEST: "SET_AMENITIES_REQUEST",
  SET_AMENITIES_RESPONSE: "SET_AMENITIES_RESPONSE",

  SET_SNACKBAR: " SET_SNACKBAR",

  VENDOR_LIST_NAME_API: "/vendors",
  VENDOR_LIST_NAME_SAGA: "VENDOR_LIST_NAME_SAGA",
  VENDOR_LIST_NAME_REQUEST: "VENDOR_LIST_NAME_REQUEST",
  VENDOR_LIST_NAME_RESPONSE: "VENDOR_LIST_NAME_RESPONSE",


  OWNER_LIST_API: "/owner-enquiry-list",
  OWNER_LIST_SAGA: "OWNER_LIST_SAGA",
  OWNER_LIST_REQUEST: "OWNER_LIST_REQUEST",
  OWNER_LIST_RESPONSE: "OWNER_LIST_RESPONSE",



  
  HOST_LIST_API: "/host-enquiry-list",
  HOST_LIST_SAGA: "HOST_LIST_SAGA",
  HOST_LIST_REQUEST: "HOST_LIST_REQUEST",
  HOST_LIST_RESPONSE: "HOST_LIST_RESPONSE",




};
